// Avisos: TODO lo que el cotizador quiere que la persona vea. Rojo = se pierde dinero, el dato no sirve o el PDF va a
// tronar. Un aviso rojo sin resolver NO bloquea (Diego: "sin aprobación previa"), pero para generar el PDF el vendedor
// tiene que confirmarlo con una nota, que queda en el historial (fallo ruidoso, no silencioso).
import { z } from 'zod';
import { Fecha, FechaHora, Id, OpcionId } from './basicos.ts';

export const CODIGOS_AVISO = [
  // Lectura de recibos (IA)
  'RECIBO_ILEGIBLE',
  'RECIBO_NO_ES_CFE',
  'RECIBO_INCOMPLETO',
  'FALTAN_RECIBOS',
  'RECIBOS_DE_OTRO_SERVICIO',
  'RECIBO_VIEJO',
  'TARIFA_NO_COINCIDE',
  'FACTURACION_NO_COINCIDE',
  'TITULAR_NO_COINCIDE',
  'HISTORIAL_INCOMPLETO',
  'CONSUMO_ATIPICO',
  'DATO_DUDOSO',
  'FALTA_DATO',
  'ARCHIVO_NO_LEIBLE_POR_IA',
  /** El recibo trae NETMET o el cliente ya tiene paneles y el cuestionario no dice "ampliación". */
  'YA_TIENE_PANELES',
  /** El mismo recibo (mismo periodo del mismo servicio) se subió dos veces. */
  'RECIBO_REPETIDO',
  /** Etapa 4 (Diego, 12-oct, punto 7): recibos PDF de CFE leídos por el LECTOR SIN IA (gratis, sin internet). Info. */
  'LECTURA_SIN_IA',
  /** Etapa 4 (Diego, 12-oct, punto 7): "después de leer, el vendedor revisa, autoriza o corrige la tabla antes de calcular".
   *  Mientras la tabla leída no esté autorizada, no se calcula (las opciones esperan). Info: es el paso que sigue. */
  'LECTURA_POR_AUTORIZAR',
  // Precio y rentabilidad (motor + IA)
  'PIERDE_DINERO',
  'MARGEN_BAJO',
  'PRECIO_FUERA_DE_RANGO',
  'FIJOS_ENCARECEN',
  'RETORNO_LARGO',
  'AHORRO_NULO',
  'COBERTURA_FUERA_DE_BANDA',
  'DEMANDA_NO_BAJA',
  'COSTO_SIN_CONFIRMAR',
  /** LEGADO (antes de la ADENDA A0): la cotización de FINSUS copiada de su PDF no cuadraba. Desde A0 ya no se copia
   *  FINSUS y el motor deja de emitirlo; con un resultado A0 solo podría ser "info" (ver problemasFinsusA0). */
  'FINSUS_NO_CUADRA',
  /** ADENDA A0: nota INFORMATIVA sobre la mensualidad de referencia de FINSUS (p. ej. "el contado está fuera del rango
   *  de las cotizaciones de referencia; se calcula igual"). Solo puede ser nivel "info" (el esquema lo exige). */
  'FINSUS_REFERENCIA',
  'AJUSTE_MANUAL',
  /** ADENDA A0b: el precio de una opción quedó más abajo de la tabla que el tope sin aprobación (5 %): pide el OK de Diego. */
  'DESCUENTO_SIN_APROBAR',
  /** ADENDA A0b: el contado por watt quedó debajo del PISO de la tabla ("candado que solo abre Diego"). */
  'DEBAJO_DEL_PISO',
  /** Un renglón de la tabla que aplica no tiene monto (p. ej. UVIE de 500 kW o más: "pedir a Diego"). */
  'COSTO_SIN_MONTO',
  /** Se quitó un recibo que alimenta la lectura y quedan otros: sus datos siguen ahí hasta volver a leer. No se confirma
   *  con nota (hay que volver a leer o capturar a mano). */
  'RECIBO_QUITADO',
  /** Tanda 1c (25-oct): un recibo ENTERO más viejo que el año que se cotiza (al subir el nuevo, el viejo sale): no se usó y
   *  no cuenta en los 12. Amarillo, a la vista y se cierra con «Entendido» (RECIBO_QUITADO es otra cosa: un archivo quitado
   *  que no se confirma con nota). */
  'RECIBO_FUERA_DEL_ANIO',
  /** Baterías: la tabla de precios no trae precio para el banco o el inversor híbrido: el nivel sale SIN precio. */
  'RESPALDO_SIN_PRECIO',
  /** Diego, 12-oct: el cuestionario dice PTR, suelo o carport (la estructura ya va dentro del precio del sistema) y además
   *  hay un adicional del catálogo que cobra estructura: sería cobrarla dos veces. No se confirma con nota: se quita el
   *  adicional o se cambia la estructura del cuestionario. */
  'ESTRUCTURA_DOBLE',
  /** Etapa 2 (12-oct): al recalcular una cotización ya calculada, una opción del MISMO tamaño (mismos paneles) cambió de
   *  inversores (p. ej. una de media tensión hecha antes de la pregunta obligatoria del transformador). Amarillo: no cambia
   *  en silencio. Vive hasta el siguiente cálculo (queda además en el historial). */
  'CAMBIO_AL_RECALCULAR',
  /** Etapa 2 (12-oct): al recalcular, el color del semáforo de margen de una opción del mismo tamaño cambió. Solo colores
   *  (sin %): lo ven Diego y los asesores internos; a un externo el servidor se lo quita (vista.ts), como el semáforo. */
  'SEMAFORO_CAMBIO',
  /** Diego, 13-oct (19:05, punto q): una opción con precio escrito a mano cambió de tamaño (paneles) por cualquier lado
   *  (tabla de recibos, consumo, cuestionario, IA, cobertura): el servidor suelta el precio a mano y vuelve al de la tabla.
   *  Amarillo; vive hasta que el vendedor lo confirma o escribe otro precio en esa opción. */
  'PRECIO_SUELTO',
  /** Diego, 13-oct (19:05, punto r): GDMTO/GDMTH con un mes que, según el recibo, pagó menos que el cargo fijo de CFE: el
   *  motor usa el mínimo de CFE para ese mes (piso, ahorro y PDF). Amarillo: el PDF sale. */
  'PAGO_BAJO_MINIMO',
  /** Etapa 3 (Diego, 12-oct, punto 1): regla de generación distribuida, interconexión o UVIE/UIIE que aplica a la cotización
   *  (motor/datos/regulacion-gd.json, cada una con su fuente y fecha en `fuente`). Sugiere, no bloquea: el ROJO es solo lo
   *  que pasa el límite de la ley (0.7 MW o más de inversores: no se cotiza y el PDF no sale; Diego, 13-oct) y no se confirma
   *  con nota (CODIGOS_QUE_NO_SE_CONFIRMAN). */
  'REGULACION',
  /** Etapa 3 (Diego, 12-oct, puntos 2 y 3): el sol del municipio de la obra (menos sol que Hermosillo → generación sugerida)
   *  y la generación por kW que eligió el vendedor para ESTA cotización (más baja, o más alta a sabiendas). */
  'GENERACION',
  /** OPTIMUS (Diego, 12-oct noche): el precio de la cotización no es el que le toca a su vendedor (se hizo antes de que Diego
   *  lo marcara de Optimus, se le quitó la casilla o se reasignó a otro). El precio NO cambia solo: «Aplicar el precio de…»
   *  lo recalcula (POST …/precio-optimus) o se confirma con una nota si el cliente ya tiene ese precio. Rojo: el PDF no sale
   *  sin una de las dos. */
  'PRECIO_OPTIMUS',
  'PROMO_ACTIVA',
  'PROMO_VENCIDA',
  'PROMO_NO_APLICA',
  /** Diego, 24-oct: proyecto FUERA de Hermosillo (por el municipio de la obra) sin viáticos capturados en Costos adicionales
   *  (renglón «viaticos» del catálogo, o un concepto que diga viáticos, con monto mayor a $0). Rojo que NO se confirma con
   *  nota (CODIGOS_QUE_NO_SE_CONFIRMAN) y que además DETIENE el PDF (faltanViaticos): «que obligue al vendedor a ponerle los
   *  viáticos en el costo». Con los viáticos capturados el motor deja un amarillo OTRO con el monto. */
  'FALTAN_VIATICOS',
  /** ADENDA z46-7 (P19, Diego 27-oct: «UN VIÁTICO POR CIUDAD (no uno por sucursal)»): sucursal de un multisitio cuya ciudad ya
   *  lleva los viáticos en OTRA sucursal del proyecto (la de folio más bajo que los trae; si ninguna, la de folio más bajo).
   *  info: esta no los lleva (sale en el PDF de todas sin viáticos; su PDF INDIVIDUAL no sale sin los suyos: faltanViaticos).
   *  amarillo: esta TAMBIÉN los trae (se cobrarían dos veces): el PDF de todas no sale hasta quitarlos (viaticosPorCiudad). */
  'VIATICOS_DE_LA_CIUDAD',
  /** Juan Carlos, 23-oct (E7, 25-oct): AISLADO sin los equipos que van a funcionar. Sin ellos no hay baterías, inversor ni
   *  precio (un aislado sin baterías no funciona): la cotización se calcula con los paneles, pero este rojo NO se confirma con
   *  nota y DETIENE el PDF (pdfDetenidoPor) hasta que se capturen los equipos. Antes tumbaba el cálculo con una excepción. */
  'FALTAN_EQUIPOS_AISLADO',
  /** Verificación de la E7 (25-oct): AISLADO cuyo inversor con baterías no recibe directo (CD) los paneles de alguna opción
   *  (sin su ficha de FV o no caben ni con varios). Sin red de CFE no funciona con inversor de red + baterías en CA: rojo que
   *  NO se confirma con nota (CODIGOS_QUE_NO_SE_CONFIRMAN): el PDF no sale hasta elegir otro inversor o agregar su ficha. */
  'AISLADO_SIN_CD',
  /** Barrido del 25-oct (R3, 3a; D4 de Diego): con aumento de consumo, la Holgada no cubre ni el COBERTURA_FUTURA_MIN (60 %, lo
   *  que cubre un Arranque) del consumo FUTURO. La variante de aumento de la plantilla truena con eso: antes salía un amarillo
   *  falso («lo más que acepta el PDF») y después un 422 «problema del formato». Rojo que NO se confirma y DETIENE el PDF. */
  'AUMENTO_NO_CABE',
  /** Barrido del 25-oct (R3, 3c; D2 de Diego): una opción de 1 solo panel (casa de menos de 2 paneles): con un panel el inversor
   *  no arranca y no se arma ninguna cadena. No se cotiza: rojo que NO se confirma, DETIENE el PDF y dice «cotiza a mano». */
  'SIN_CADENAS',
  /** ALTA de inversores (26-oct-2026, plan §2.3): el vendedor eligió a mano un inversor BLOQUEADO en datos/respaldo.json (SPF sin
   *  corriente por MPPT, Solis sin garantía en México, Sol-Ark sin baterías por modelo). Rojo que NO se confirma y DETIENE el PDF:
   *  falta un dato del proveedor, no una opinión del vendedor. */
  'INVERSOR_BLOQUEADO',
  /** 26-oct-2026: ningún inversor aguanta la carga del respaldo ni con su máximo en paralelo (66 kW con 6 SPH 10K = 60 kW). Antes
   *  se cotizaba DE MENOS en silencio. Rojo que NO se confirma y DETIENE el PDF: dice cuánto pide la carga y cuánto da el máximo. */
  'INVERSOR_NO_ALCANZA',
  /** ADENDA z53-4 (28-oct-2026, listas de octubre; parámetro de versión respaldo_oct26): las baterías del nivel no dan la POTENCIA
   *  que pide la casa (continua o de arranque, de la ficha de la batería) o los Ah mínimos del inversor (SNA-US 6000: 200 Ah). El
   *  BMS cortaría el respaldo: rojo que NO se confirma y DETIENE el PDF; dice cuántas hacen falta. */
  'BATERIA_NO_ALCANZA',
  /** Ampliación de baterías (27-oct-2026): falta un dato para el precio (la batería, cuántas tiene, cuántas se suman, un
   *  costo) o pasa del máximo en paralelo de la ficha. Rojo que NO se confirma y DETIENE el PDF (sin precio no hay propuesta). */
  'AMPLIACION_INCOMPLETA',
  /** Ampliación de baterías: la noche medida de la hoja 2 no cuadra con los candados de la plantilla (horas cruzadas, banco
   *  que no empezó lleno…). Rojo que NO se confirma y DETIENE el PDF: la plantilla lo rechazaría (nunca prometer de más). */
  'AMPLIACION_NOCHE',
  /** ADENDA z48 (28-oct-2026, «un fallo ruidoso vale más que uno silencioso»): cotización de BATERÍAS sin decir qué respaldo lleva
   *  (respaldo, híbrido): sin eso no hay baterías ni precio de respaldo. Antes era un amarillo y salía una propuesta de paneles solos.
   *  Rojo que NO se confirma y DETIENE el PDF; se arregla en el cuestionario («Qué cotizas»). */
  'BATERIAS_SIN_RESPALDO',
  /** ADENDA z48: híbrido o respaldo y la tabla de precios no trae NINGÚN inversor híbrido apto (con ficha de aptitud y sin bloquear):
   *  se enseña la ficha sin precio. Antes era amarillo. Rojo que NO se confirma y DETIENE el PDF; Diego lo agrega en la tabla. */
  'SIN_HIBRIDO_APTO',
  /** RECORTE DE PUNTA (ADENDA z54/z55-2, 29-oct-2026): la batería grande no se ofrece (no es GDMTH de Noroeste, faltan recibos,
   *  recorta en menos de 8 de 12 meses, se paga en más de 5 años, un gabinete pasa la demanda contratada…). Rojo que NO se confirma
   *  con nota y DETIENE el PDF (nunca prometer de más): se arregla el dato o se cotizan paneles. */
  'RECORTE_NO_SE_OFRECE',
  /** hoy86 (verificación de la 6.ª vuelta, 1-nov): una CASA con meses que «Sugerir con IA» estimó cuando era negocio (se corrigió el
   *  tipo de cliente). La plantilla no acepta «ia» en residencial y decir «casas parecidas» de lo que estimó la IA sería falso: antes
   *  era un 422 «problema del formato… ya se le avisó a Diego», sin aviso previo y sin salida a la vista. Rojo que NO se confirma y
   *  DETIENE el PDF; se arregla en Revisión con «Volver a llenar con la curva» o escribiendo los kWh. */
  'MESES_IA_EN_CASA',
  /** Recorte de punta que SÍ se ofrece pero con algo que revisar antes de mandar (retorno de 4 a 5 años o con 2 meses fallados de
   *  más de 5, cotización del gabinete vencida, transformador estimado, demanda contratada sin leer, recarga que puede subir la
   *  demanda máxima, desde 1 MW…). Amarillo. */
  'RECORTE_REVISAR',
  // IA
  'IA_SIN_LLAVE',
  'IA_SIMULADA',
  'IA_ERROR',
  'IA_TOPE_GASTO',
  'IA_RECHAZO',
  // PDF
  'PDF_FALLO',
  'PDF_FORMATO_NO_EXISTE',
  'PDF_ASESOR_NO_REGISTRADO',
  'VARIANTE_NO_SOPORTADA',
  'OTRO',
] as const;
export const CodigoAviso = z.enum(CODIGOS_AVISO);
export type CodigoAviso = z.infer<typeof CodigoAviso>;

export const NivelAviso = z.enum(['rojo', 'amarillo', 'info']);
export type NivelAviso = z.infer<typeof NivelAviso>;

/** Quién levantó el aviso. Al recalcular, el servidor reemplaza los avisos de ese origen (no los acumula). */
export const OrigenAviso = z.enum(['ia_lectura', 'ia_revision', 'motor', 'pdf', 'sistema']);
export type OrigenAviso = z.infer<typeof OrigenAviso>;

/** Etapa 3: de dónde sale un aviso de regulación o de sol (texto corto con su publicación, la fecha en que se revisó y el
 *  enlace), para que el vendedor lo vea junto al aviso. */
export const FuenteAviso = z.strictObject({
  texto: z.string().trim().min(3).max(200),
  /** Cuándo se revisó que sigue vigente (AAAA-MM-DD). */
  fecha: Fecha,
  url: z.string().regex(/^https:\/\//).max(400).nullable(),
});
export type FuenteAviso = z.infer<typeof FuenteAviso>;

export const Aviso = z.strictObject({
  id: Id,
  codigo: CodigoAviso,
  nivel: NivelAviso,
  origen: OrigenAviso,
  /** Español de México, dirigido al vendedor: qué pasa y qué hacer. */
  mensaje: z.string().trim().min(3).max(600),
  /** JSON pointer del dato al que se refiere (relativo al borrador), si aplica. */
  campo: z.string().regex(/^\//).nullable(),
  opcion: OpcionId.nullable(),
  creado_en: FechaHora,
  resuelto: z.boolean(),
  resuelto_por: Id.nullable(),
  /** Nota con la que el vendedor lo confirmó ("el cliente aceptó pagar la mufa aparte"). */
  nota: z.string().trim().max(500).nullable(),
  /** Etapa 3: la fuente de un aviso de regulación o de sol. Ausente = aviso sin fuente legal (los de siempre). */
  fuente: FuenteAviso.optional(),
}).superRefine((a, ctx) => {
  const max = NIVEL_MAXIMO_AVISO[a.codigo];
  if (max && RANGO_NIVEL[a.nivel] > RANGO_NIVEL[max])
    ctx.addIssue({ code: 'custom', path: ['nivel'], message: `El aviso ${a.codigo} solo puede ser "${max}" (vino "${a.nivel}").` });
});
export type Aviso = z.infer<typeof Aviso>;

const RANGO_NIVEL: Readonly<Record<NivelAviso, number>> = Object.freeze({ info: 0, amarillo: 1, rojo: 2 });

/** Nivel MÁXIMO que admite un código (el esquema de Aviso truena si se pasa). ADENDA A0: FINSUS es informativo. */
export const NIVEL_MAXIMO_AVISO: Readonly<Partial<Record<CodigoAviso, NivelAviso>>> = Object.freeze({ FINSUS_REFERENCIA: 'info' });

/** ADENDA A0b: avisos ROJOS que, según Diego, NO se resuelven con la nota de un vendedor sino con su OK: descuento mayor
 *  al tope, precio debajo del piso ("candado que solo abre Diego"), margen debajo del mínimo o pérdida, y renglones sin
 *  monto. El motor los emite; el SERVIDOR es quien debe negar el PDF hasta que un director los apruebe. */
export const CODIGOS_QUE_APRUEBA_DIEGO: readonly CodigoAviso[] = Object.freeze(['DESCUENTO_SIN_APROBAR', 'DEBAJO_DEL_PISO', 'PIERDE_DINERO', 'MARGEN_BAJO', 'COSTO_SIN_MONTO']);

/** Avisos rojos que NO se confirman con nota: hay que arreglar el dato (el PDF no sale mientras estén). Etapa 3: el rojo de
 *  REGULACION es lo que pasa el límite de la ley (0.7 MW o más de inversores; generación distribuida es menos de 0.7 MW):
 *  nadie lo "confirma" y no hay otro camino (Diego, 13-oct: «si no se puede, no se puede»): se baja el sistema. */
export const CODIGOS_QUE_NO_SE_CONFIRMAN: readonly CodigoAviso[] = Object.freeze(['RECIBO_QUITADO', 'ESTRUCTURA_DOBLE', 'REGULACION', 'FALTAN_VIATICOS', 'FALTAN_EQUIPOS_AISLADO', 'AISLADO_SIN_CD', 'AUMENTO_NO_CABE', 'SIN_CADENAS', 'INVERSOR_BLOQUEADO', 'INVERSOR_NO_ALCANZA', 'BATERIA_NO_ALCANZA', 'AMPLIACION_INCOMPLETA', 'AMPLIACION_NOCHE', 'BATERIAS_SIN_RESPALDO', 'SIN_HIBRIDO_APTO', 'RECORTE_NO_SE_OFRECE', 'MESES_IA_EN_CASA', 'PROMO_VENCIDA', 'PROMO_NO_APLICA']);

/** Avisos rojos que SOLO Diego confirma con una nota (nadie más, ni en «Generar PDF»): mantener un precio que no es el que le
 *  toca al vendedor (PRECIO_OPTIMUS, Diego 12-oct noche). El vendedor tiene su botón para arreglarlo («Aplicar el precio…»). */
export const CODIGOS_QUE_SOLO_CONFIRMA_DIEGO: readonly CodigoAviso[] = Object.freeze(['PRECIO_OPTIMUS']);

/** Los avisos rojos (resueltos o no) que piden el OK de Diego. */
export function avisosQueApruebaDiego(avisos: readonly Aviso[]): Aviso[] {
  return avisos.filter((a) => a.nivel === 'rojo' && CODIGOS_QUE_APRUEBA_DIEGO.includes(a.codigo));
}

/** AUTORIZACIONES (Diego, 11-oct; "verde manda", 12-oct): de los que piden OK, los que TAMBIÉN pueden autorizar Miguel Cota
 *  y Juan Carlos Cortés (asesores internos, permiso `autorizar_descuentos`): el descuento contra la tabla (más del tope o
 *  debajo del 30 % de margen). Debajo del piso, del margen mínimo, con pérdida o con un renglón sin monto: solo Diego. */
export const CODIGOS_QUE_AUTORIZAN_INTERNOS: readonly CodigoAviso[] = Object.freeze(['DESCUENTO_SIN_APROBAR']);

/** ¿Todos los avisos que piden OK los puede autorizar un asesor interno? (false si no hay ninguno). */
export function soloDescuentosQueAutorizanInternos(avisos: readonly Aviso[]): boolean {
  const de = avisosQueApruebaDiego(avisos);
  return de.length > 0 && de.every((a) => CODIGOS_QUE_AUTORIZAN_INTERNOS.includes(a.codigo));
}

/** Códigos que hablan de FINSUS. */
export const CODIGOS_AVISO_FINSUS: readonly CodigoAviso[] = Object.freeze(['FINSUS_NO_CUADRA', 'FINSUS_REFERENCIA']);

/** ¿Este aviso es "de FINSUS"? Por su código o porque apunta a /parametros/finsus o /parametros/formas_de_pago/finsus.
 *  Con un resultado A0 del motor todos estos son nivel "info" (ADENDA A0: nada de avisos rojos por FINSUS; el que quede,
 *  informativo y discreto). */
export function esAvisoFinsus(a: Pick<Aviso, 'codigo' | 'campo'>): boolean {
  if (CODIGOS_AVISO_FINSUS.includes(a.codigo)) return true;
  const c = a.campo ?? '';
  return /^\/parametros\/finsus(\/|$)/.test(c) || /^\/parametros\/formas_de_pago\/finsus$/.test(c);
}

/** Avisos rojos sin resolver: la interfaz los enseña arriba y el PDF pide confirmarlos. */
export function rojosPendientes(avisos: readonly Aviso[]): Aviso[] {
  return avisos.filter((a) => a.nivel === 'rojo' && !a.resuelto);
}

/** Reemplaza los avisos de un origen por los nuevos, conservando la resolución de los que siguen iguales
 *  (mismo código, campo y opción): un aviso ya confirmado no vuelve a pedir confirmación si nada cambió. */
export function reemplazarAvisos(actuales: readonly Aviso[], origen: OrigenAviso, nuevos: readonly Aviso[]): Aviso[] {
  const llave = (a: Aviso) => `${a.codigo}|${a.campo ?? ''}|${a.opcion ?? ''}|${a.mensaje}`;
  const previos = new Map(actuales.filter((a) => a.origen === origen && a.resuelto).map((a) => [llave(a), a] as const));
  const otros = actuales.filter((a) => a.origen !== origen);
  const repuestos = nuevos.map((n) => {
    if (n.origen !== origen) throw new Error(`reemplazarAvisos: un aviso nuevo dice origen "${n.origen}" y se reemplaza "${origen}"`);
    const p = previos.get(llave(n));
    return p ? { ...n, resuelto: true, resuelto_por: p.resuelto_por, nota: p.nota } : n;
  });
  return [...otros, ...repuestos];
}
